import { render, staticRenderFns } from "./RiwayatPasienDetail.vue?vue&type=template&id=741d9670&scoped=true"
import script from "./RiwayatPasienDetail.vue?vue&type=script&lang=js"
export * from "./RiwayatPasienDetail.vue?vue&type=script&lang=js"
import style0 from "./RiwayatPasienDetail.vue?vue&type=style&index=0&id=741d9670&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741d9670",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('741d9670')) {
      api.createRecord('741d9670', component.options)
    } else {
      api.reload('741d9670', component.options)
    }
    module.hot.accept("./RiwayatPasienDetail.vue?vue&type=template&id=741d9670&scoped=true", function () {
      api.rerender('741d9670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/riwayat_pasien/RiwayatPasienDetail.vue"
export default component.exports